import { jwtDecode } from 'jwt-decode'
import dayjs from 'lib/dayjs'

const isClientSessionExpired = (clientSession: string) => {
  const decoded: any = jwtDecode(clientSession)

  return (
    !decoded ||
    !decoded?.datetime ||
    dayjs(decoded?.datetime * 1000)
      .add(23, 'hour')
      .isBefore(dayjs(new Date()))
  )
}

export default isClientSessionExpired
